import bus from '@/lib/bus';
import { contextMenuStore } from '@/components/ContextMenu/store/contextMenuStore';
import { isWechatBrowser } from '@/lib/utils';

export function useContextMenuListener() {
  const store = contextMenuStore();
  let mobileTimeOut: ReturnType<typeof setTimeout>;
  const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator?.userAgent);
  if (!isIOS || !isWechatBrowser) {
    window.addEventListener('contextmenu', (e: any) => {
      const path = e.path || e.composedPath();
      const id = getTargetIdValue(path);
      // 编辑器，展示默认右键效果
      if (!id || id.indexOf('w-e-textarea') !== -1 || id.indexOf('w-e-element') !== -1) {
        return;
      }
      e.preventDefault();
      if (id) {
        store.setTargetId(id);
        store.changeXY(e.clientX, e.clientY);
      }
    });
  } else if (isWechatBrowser) {
    // 添加移动端长按事件
    window.addEventListener('touchstart', (e: any) => {
      mobileTimeOut = setTimeout(() => {
        const path = getComposedPath(e);
        const id = path && getTargetIdValue(path);
        if (!id || id?.indexOf('w-e-textarea') !== -1 || id?.indexOf('w-e-element') !== -1) {
          return;
        }
        e.clientX = e.touches[0]?.pageX;
        e.clientY = e.touches[0]?.pageY;
        e?.preventDefault && e.preventDefault();
        if (id) {
          store.setTargetId(id);
          store.changeXY(e.clientX, e.clientY);
        }
      }, 300);
    });
    window.addEventListener('touchend', (e: any) => {
      clearTimeout(mobileTimeOut);
    });
    window.addEventListener('touchMove', (e: any) => {
      clearTimeout(mobileTimeOut);
    });
  }
}

function getComposedPath(e: any) {
  if (e.path) {
    return e.path;
  }
  let target = e.target;
  e.path = [e.target];
  while (target?.parentNode !== null) {
    e.path.push(target.parentNode);
    target = target.parentNode;
  }
  e.path.push(document, window);
  return e.path;
}

export function setContextMeneShow(isShow: boolean) {
  const store = contextMenuStore();
  store.changeShow(isShow);
}

export function useMouseClickListener() {
  const store = contextMenuStore();
  window.addEventListener('click', (e) => {
    store.changeShow(false);
    e.preventDefault();
  });
}

// 根据targetPath向上寻找有绑定ID的元素的ID值
function getTargetIdValue(targetPath: Array<any>) {
  return targetPath.find((i) => i?.attributes?.id?.value)?.attributes?.id?.value;
}
